var sharedStyles = {
  "RangeSlider": "Polaris-RangeSlider",
  "Track--dashed-after": "Polaris-RangeSlider--trackDashedAfter",
  "Track--dashed": "Polaris-RangeSlider--trackDashed"
};

export { sharedStyles as default };
